/**
 * Activity tracking module for session replay
 */

import { sessionState } from './state';

/**
 * Update last activity time (called on user interactions)
 */
export function recordActivity(): void {
  sessionState.lastActivityTime = Date.now();
}

/**
 * Set up activity event listeners for idle detection
 */
export function setupActivityListeners(): void {
  const activityEvents = ["mousedown", "keydown", "scroll", "touchstart"];
  activityEvents.forEach(function (eventName) {
    window.addEventListener(eventName, recordActivity, { passive: true });
  });
}
